import React, { useState } from 'react';

import { deleteProductCacheByCampaignId } from 'services/api/admin-campaigns';
import BaseModal from 'shared-components/BaseModal/Modal';

const styles = {
  content: {
    padding: 20,
  },
  heading: {
    textAlign: 'center',
  },
  buttonContainer: {
    display: 'flex',
    justifyContent: 'space-around',
  },
  submitButton: {
    textTransform: 'uppercase',
    letterSpacing: 1,
    lineHeight: 1.13,
    fontWeight: 500,
    padding: 16,
    fontSize: 16,
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    height: 48,
    fontFamily: 'Nunito Sans, sans-serif',
    backgroundColor: 'white',
    color: '#ff5b5d',
    border: 'solid 1px #ff5b5d',
    cursor: 'pointer',
    width: 200,
  },
  cancelButton: {
    textTransform: 'uppercase',
    letterSpacing: 1,
    lineHeight: 1.13,
    fontWeight: 500,
    padding: 16,
    fontSize: 16,
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    height: 48,
    fontFamily: 'Nunito Sans, sans-serif',
    color: '#666666',
    cursor: 'pointer',
    width: 200,
  },
};

const FlushCacheModal = ({ isOpen, onRequestClose, campaignId }) => {
  const [isLoading, setLoading] = useState(false);

  const flushCache = () => {
    setLoading(true);
    deleteProductCacheByCampaignId(campaignId)
      .then(() => {
        setLoading(false);
        onRequestClose();
      })
      .catch(() => {
        setLoading(false);
        // eslint-disable-next-line no-alert
        alert('Whoops! Something went wrong.');
      });
  };

  return (
    <BaseModal isOpen={isOpen} showCloseIcon onRequestClose={onRequestClose}>
      <div style={styles.content}>
        <h1 style={styles.heading}>Are you sure?</h1>
        <p>
          Flushing the cache will affect members&apos; experience during a Live{' '}
          Sale.
        </p>
        <div style={styles.buttonContainer}>
          <button
            type="button"
            onClick={onRequestClose}
            style={styles.cancelButton}
          >
            Cancel
          </button>
          <button
            type="button"
            onClick={flushCache}
            style={styles.submitButton}
          >
            {isLoading ? (
              <i className="fas fa-spinner-third fa-spin" />
            ) : (
              'Yes, continue'
            )}
          </button>
        </div>
      </div>
    </BaseModal>
  );
};

export default FlushCacheModal;
